import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_BLOCKS = "getPaginatedBlocks";
export const ALL_BLOCKS = "getAllBlocks";
export const CREATE_BLOCK_FORM = "createBlockForm";
export const DELETE_BLOCK = "deleteBlock";
export const GET_BLOCK_DATA = "getBlockData";
export const CREATE_BLOCK = "createBlock";
export const UPDATE_BLOCK = "updateBlock";


// mutation types

export const SET_PAGINATED_BLOCKS = "setPaginatedBlocks";
export const SET_ALL_BLOCKS = "setAllBlocks";
export const SET_BLOCK_DATA = "setBlockData";
export const SET_BLOCK_META = "setBlockMeta";
export const SET_BLOCK_ERROR = "setBlockError";
export const SET_BLOCK_LOADING = "setBlockLoading";
export const CLEAR_BLOCK_ERROR = "clearBlockError";
export const SET_IS_DISABLED_BLOCK = "setIsDisabledBlock";


const state = {
    blocks: [],
    paginatedBlocks: [],
    block_data: {},
    meta_block : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllBlocks(state) {
        return state.paginatedBlocks;
    },

    allBlocks(state) {
        return state.blocks;
    },

    getBlockData(state) {
        return state.block_data;
    },

    meta_block(state) {
        return state.meta_block;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_BLOCKS](context, payload) {
        context.commit(SET_IS_DISABLED_BLOCK, false);
        context.commit(SET_BLOCK_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/blocks?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_BLOCK_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_BLOCKS, data);
                context.commit(SET_BLOCK_META, data);
                context.commit(SET_BLOCK_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_BLOCK_LOADING, false);
            context.commit(SET_BLOCK_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_BLOCKS]() {
        return new Promise(resolve => {
            ApiService.get('/blocksAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_BLOCK_FORM](context) {
        context.commit(SET_BLOCK_LOADING, false);
        context.commit(SET_BLOCK_ERROR, false);
        context.commit(SET_IS_DISABLED_BLOCK, false);
    },

    [GET_BLOCK_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_BLOCK, true);
        context.commit(SET_BLOCK_LOADING, true);
        context.commit(CLEAR_BLOCK_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/block/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_BLOCK_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_BLOCK_DATA, response.data);
                    context.commit(SET_BLOCK_LOADING, false);
                    context.commit(SET_IS_DISABLED_BLOCK, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_BLOCK_LOADING, false);
                context.commit(SET_BLOCK_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_BLOCK, true);
            });
        });
    },

    [CREATE_BLOCK](context, payload) {
        context.commit(SET_BLOCK_LOADING, false);
        context.commit(SET_IS_DISABLED_BLOCK, true);
        context.commit(CLEAR_BLOCK_ERROR);
        return ApiService.post("/block/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_BLOCK_ERROR);
            }
            else{
                context.commit(SET_BLOCK_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Blok başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_BLOCK_ERROR);
                context.commit(SET_IS_DISABLED_BLOCK, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_BLOCK_LOADING, false);
            context.commit(SET_BLOCK_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_BLOCK, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_BLOCK](context, payload) {
        context.commit(SET_BLOCK_LOADING, true);
        context.commit(SET_IS_DISABLED_BLOCK, true);
        context.commit(CLEAR_BLOCK_ERROR);
        
        return ApiService.put(`/block/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_BLOCK_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı blok başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_BLOCK, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_BLOCK_LOADING, false);
            context.commit(SET_BLOCK_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_BLOCK, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_BLOCK](context, payload) {
        context.commit(SET_BLOCK_LOADING, true);
        context.commit(CLEAR_BLOCK_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/block/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_BLOCK_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı blok başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_BLOCK_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_BLOCKS](state, paginatedBlocks) {
        state.paginatedBlocks = paginatedBlocks.data;
    },

    [SET_ALL_BLOCKS](state, blocks) {
        state.blocks = blocks;
    },

    [SET_BLOCK_DATA](state, blocks_data) {
        state.blocks_data = blocks_data;
        state.errors = [];
    },

    [SET_BLOCK_META](state, meta_block) {
        state.meta_block = meta_block;
    },

    [SET_BLOCK_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_BLOCK_ERROR](state) {
        state.errors = [];
    },
    
    [SET_BLOCK_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_BLOCK](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
